import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="not-found-container">
            <h1 className="not-found-heading">404 Page Not Found</h1>
            <p className="not-found-text">Oops! The page you are looking for does not exist.</p>
            <div className="animation-container">
                <div className="animation-item" />
                <div className="animation-item" />
                <div className="animation-item" />
            </div>
            <Link to="/">
                <button className="back-button">Go Back to Home</button>
            </Link>
        </div>
    );
};

export default NotFound;
